import React from 'react';

import { Checkbox, Form } from 'antd';

import { getIn } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface IProps extends FieldProps {
  label: string;
  fullWidth?: boolean;
  checked?: boolean;
}

export const CheckboxFormField = ({ field, form, label, checked, fullWidth = true, ...props }: IProps) => {
  const errorText = getIn(form.errors, field.name);

  function handleChange(e: any) {
    form.setFieldValue(field.name, e.target.checked);
  }

  return (
    <Form.Item
      className={fullWidth ? 'mb-0 w-full' : 'mb-0'}
      help={errorText}
      validateStatus={errorText ? 'error' : undefined}
    >
      <Hint inputName={field.name}>
        <Checkbox checked={checked || !!field.value || false} onChange={handleChange} {...props}>
          {label}
        </Checkbox>
      </Hint>
    </Form.Item>
  );
};
